import StationDataHandler from "./StationDataHandler";
import TiledPoiLayer from "./TiledPoiLayer";
import overlays from "../../app/overlays";
import layers from "../../app/layers";

/**
 * Clase que maneja los datos de temperatura (TempDataHandler).
 * Extiende la funcionalidad de `StationDataHandler` para gestionar la visualización de la temperatura de las estaciones.
 */
class TempDataHandler extends StationDataHandler {
    /**
     * Inicializa las propiedades específicas del controlador de temperatura.
     */
    initProperties() {
        this.ident = "temp"; // Identificador del controlador.
        super.initProperties();
        this.ovrIdent = "temp2m"; // Identificador del overlay de temperatura.
        this.overlay = overlays.temp2m; // Overlay asociado a la temperatura.
        this.displayItem = (o, t) => null !== o.temp[t]; // Función para determinar si un elemento debe mostrarse.
        this.layer = new TiledPoiLayer(this, this.generalOptions); // Capa de puntos de interés para la temperatura.
    }

    /**
     * Actualiza un elemento HTML con los datos de temperatura.
     *
     * @param {HTMLElement} element - El elemento HTML que se actualizará.
     * @param {Object} tempData - Los datos de temperatura.
     * @param {number} index - El índice del dato de temperatura.
     */
    updateElement(element, tempData, index) {
        const temperature = tempData.temp[index]; // Obtiene la temperatura del índice especificado.
        this.updateElementFromNumber(element, temperature); // Actualiza el elemento con el valor de temperatura.
    }

    /**
     * Convierte los datos meteorológicos de un POI a una cadena HTML.
     *
     * @param {Object} poiData - Los datos del POI.
     * @returns {string} La cadena HTML generada.
     */
    wx2string2(poiData) {
        let html = "";

        if (typeof poiData.temp === "number" && !isNaN(poiData.temp)) {
            const n = layers.temp2m.m.convertValue.call(layers.temp2m.m, poiData.temp, " "); // Convierte el valor de temperatura.
            const r = layers.temp2m.c.colorDark(poiData.temp, 20); // Calcula el color basado en la temperatura.
            html += `<span class="rounded-box" style="background: ${r}">${n}</span>`; // Genera el HTML con el valor y el color.
        }

        return html;
    }
}

export default TempDataHandler;
